(function () {
  document.addEventListener("DOMContentLoaded", async () => {
    const wrapper = document.querySelector(".fitments-wrapper");
    let loader = document.querySelector(".loader-parent");
    const tbody = document.querySelector("#makeModelTable tbody");
    const searchInput = document.querySelector("#fitmentSearch");
    const tabs = document.querySelectorAll(".fitment-tab");
    if (!wrapper || !loader || !tbody) return;

    const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    const country = (wrapper.dataset.country || "").toUpperCase();
    const allDataUrl = wrapper.dataset.allDataUrl;
    const allFitmentsPage = wrapper.dataset.allFitmentsPage || `${ROOT}pages/all-fitments`;
    // translated UI text (locale keys custom.fitments.*) — vehicle data is never translated
    const T = wrapper.dataset;

    // Anti-Theft (Pro Sockets)
    const pro_sockets = document.querySelector("#makeModelTable").dataset.prosockets;
    const testPro = pro_sockets.split('""');
    const proSocketsArr = [];
    testPro.forEach((item) => {
      proSocketsArr.push(item.replaceAll('"', "").trim());
    });
    const isAntiTheft = (socket) => proSocketsArr.includes(String(socket || "").split("-")[0].trim());

    const norm = (s) => (s || "").toString().toLowerCase().trim();
    const nospace = (s) => norm(s).replace(/\s+/g, "");
    const slug = (s) => norm(s).replace(/\s+/g, "-");
    const modelKey = (make, model) => `${norm(make)}|${norm(model)}`;
    const debounce = (fn, ms = 250) => {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn(...args), ms);
      };
    };

    /* "1st Gen (2017-2020)" → { body: "1st Gen", year: "(2017-2020)" } */
    function splitBodyYear(rawBody) {
      let body = rawBody || "";
      let year = "";
      const yearMatch = body.match(/\(\d{4}[^)]*\)/);
      if (yearMatch) {
        year = yearMatch[0];
        body = body.replace(yearMatch[0], "").trim();
      }
      return { body, year };
    }

    /* ── Market tab: products in this market's catalog (Storefront API, @inContext) ── */

    /* make|model → product handle of the vehicles sold in this market (filled by the market load) */
    const marketHandles = {};

    async function fetchMarketProducts() {
      let hasNextPage = true;
      let endCursor = null;
      let allVariants = [];
      const endpoint = `/api/2024-07/graphql`;
      const headers = {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": "960b68e3d27e55870e9ad333d5a199a1",
      };
      // only products available in the visitor's market
      const inContext = /^[A-Z]{2}$/.test(country) ? `@inContext(country: ${country})` : "";

      const fetchProducts = async (cursor = null) => {
        const query = `
          query ${inContext} {
            products(
              first: 250
              ${cursor ? `, after: "${cursor}"` : ""}
              query: "-product_type:'Merchandise' \
              -product_type:'Merchandise Lifestyle' \
              -product_type:'Merchant' \
              -product_type:'Main Plug' \
              -product_type:'Refurbished' \
              -product_type:'Throttle Response Controller'"
            ) {
              pageInfo {
                hasNextPage
                endCursor
              }
              nodes {
                title
                handle
                productType
                variants(first: 100) {
                  nodes {
                    title
                    id
                  }
                }
              }
            }
          }
        `;

        const response = await fetch(endpoint, {
          method: "POST",
          headers,
          body: JSON.stringify({ query }),
        });
        const data = await response.json();
        return data.data.products;
      };

      while (hasNextPage) {
        const productsData = await fetchProducts(endCursor);

        productsData.nodes.forEach((product) => {
          product.variants.nodes.forEach((variant) => {
            allVariants.push({ title: variant.title, id: variant.id, handle: product.handle });
          });
        });

        hasNextPage = productsData.pageInfo.hasNextPage;
        endCursor = productsData.pageInfo.endCursor;
      }

      return allVariants;
    }

    async function getMarketData() {
      const allVariants = await fetchMarketProducts();
      const makes = {};

      allVariants.forEach(({ title, id, handle }) => {
        const parts = title.split("/").map((item) => item.trim());
        if (typeof parts[0] !== "string" || !/^PC\d/i.test(parts[0])) return;

        const [pcCodeRaw, make, model, rawBody, rawEngine] = parts;
        const pcCode = pcCodeRaw.toUpperCase().replace(/\s+/g, "");
        const { body, year } = splitBodyYear(rawBody);
        const engine = (rawEngine || "").replace(/[()]/g, "").trim();

        if (!makes[make]) makes[make] = {};
        if (!makes[make][model]) makes[make][model] = [];

        const variantId = id ? id.split("/").pop() : null;
        const productUrl = `${ROOT}products/${handle}`;
        marketHandles[modelKey(make, model)] = handle;
        makes[make][model].push({
          body, year, engine, pcCode,
          is_anti_theft: isAntiTheft(pcCode),
          modelUrl: productUrl,
          url: variantId ? `${productUrl}?variant=${variantId}` : productUrl,
        });
      });

      return makes;
    }

    /* ── All Fitments tab: every vehicle (alladmindata.json, not market based) ── */

    /* Sold in this market → product page; otherwise → /pages/all-fitments with the selection */
    function allFitmentsUrl(fit) {
      const params = new URLSearchParams();
      ["make", "model", "body", "engine"].forEach((k) => { if (fit[k]) params.set(k, fit[k]); });
      const qs = params.toString();
      return qs ? `${allFitmentsPage}?${qs}` : allFitmentsPage;
    }

    async function getAllData() {
      const res = await fetch(allDataUrl);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const list = await res.json();
      await dataFor("market").catch(() => null); // product handles of this market decide the links
      const makes = {};

      (Array.isArray(list) ? list : []).forEach((m) => {
        if (!m || !m.make) return;
        (m.models || []).forEach((md) => {
          if (!md || !md.model) return;
          const handle = marketHandles[modelKey(m.make, md.model)];
          const productUrl = handle ? `${ROOT}products/${handle}` : null;

          (md.variants || []).forEach((v) => {
            if (!v) return;
            const socket = v.socket || "";
            const engine = v["engine-volume"] || "";
            const { body, year } = splitBodyYear(v.body);
            const fit = { make: m.make, model: md.model, body: v.body || "", engine };

            if (!makes[m.make]) makes[m.make] = {};
            if (!makes[m.make][md.model]) makes[m.make][md.model] = [];
            makes[m.make][md.model].push({
              body, year, engine,
              pcCode: socket.toUpperCase().replace(/\s+/g, ""),
              is_anti_theft: isAntiTheft(socket),
              modelUrl: productUrl || allFitmentsUrl({ make: m.make, model: md.model }),
              url: productUrl || allFitmentsUrl(fit),
            });
          });
        });
      });

      return makes;
    }

    /* ── Shared: sort, filter, render ── */

    // Year'a göre sıralama: önce başlangıç yılı, eşitse body
    const trNumericCollator = new Intl.Collator("tr", {
      sensitivity: "base",
      numeric: true,
    });

    const getStartYear = (yearStr) => {
      if (!yearStr) return Number.MAX_SAFE_INTEGER;

      const match = yearStr.match(/\d{4}/);
      return match ? parseInt(match[0], 10) : Number.MAX_SAFE_INTEGER;
    };

    function sortEntries(makes) {
      Object.keys(makes).forEach((make) => {
        Object.keys(makes[make]).forEach((model) => {
          makes[make][model].sort((a, b) => {
            const yearDiff = getStartYear(a.year) - getStartYear(b.year);
            if (yearDiff !== 0) return yearDiff;

            return trNumericCollator.compare(a.body, b.body);
          });
        });
      });
      return makes;
    }

    /* tab → Promise<makes>; each source is loaded once */
    const loaders = { market: getMarketData, all: getAllData };
    const cache = {};
    function dataFor(tab) {
      if (!cache[tab]) {
        cache[tab] = loaders[tab]().then(sortEntries).catch((err) => {
          delete cache[tab]; // allow a retry
          throw err;
        });
      }
      return cache[tab];
    }

    // filter: make model or pc  (PC36 and "PC 36" are available)
    function filterData(query, data) {
      const q = norm(query);
      const qNoSpace = nospace(query);

      if (!q) return data;

      const out = {};
      for (const make in data) {
        const models = data[make];
        const makeMatched = norm(make).includes(q);

        for (const model in models) {
          const entries = models[model];
          const modelMatched = norm(model).includes(q);

          const filteredEntries = entries.filter((e) => {
            const pcNoSpace = nospace(e.pcCode); // "PC36"
            const pcMatch =
              pcNoSpace.includes(qNoSpace) || // "pc36"
              norm(e.pcCode).includes(q); // "pc 36"
            return makeMatched || modelMatched || pcMatch;
          });

          if (filteredEntries.length) {
            if (!out[make]) out[make] = {};
            out[make][model] = filteredEntries;
          }
        }
      }
      return out;
    }

    function clearTbody() {
      while (tbody.firstChild) tbody.removeChild(tbody.firstChild);
    }

    function makeTdClickable(td, url) {
      td.style.cursor = "pointer";
      td.addEventListener("click", (e) => {
        if (e.target.closest("a")) return;
        window.open(url, "_blank", "noopener");
      });
    }

    function linkTd(text, url, label) {
      const td = document.createElement("td");
      const a = document.createElement("a");
      a.href = url;
      a.textContent = text;
      a.style.textDecoration = "underline";
      a.target = "_blank";
      a.rel = "noopener";
      a.addEventListener("click", (e) => e.stopPropagation());
      td.appendChild(a);
      if (label) td.setAttribute("data-label", label);
      makeTdClickable(td, url);
      return td;
    }

    function textTd(text, label) {
      const td = document.createElement("td");
      td.textContent = text;
      td.setAttribute("data-label", label);
      return td;
    }

    // make/model anahtarları alfabetik sırada
    function renderTableFromData(data) {
      clearTbody();

      const makeKeys = Object.keys(data).sort((a, b) => trNumericCollator.compare(a, b));

      for (const make of makeKeys) {
        const models = data[make];
        const modelKeys = Object.keys(models).sort((a, b) => trNumericCollator.compare(a, b));

        const makeRowCount = Object.values(models).reduce(
          (total, entries) => total + entries.length,
          0
        );
        if (makeRowCount === 0) continue;

        let makeRowInserted = false;

        for (const model of modelKeys) {
          const entries = models[model];
          if (!entries || !entries.length) continue;

          let modelRowInserted = false;

          entries.forEach((entry) => {
            const tr = document.createElement("tr");

            if (!makeRowInserted) {
              const tdMake = linkTd(make, `${ROOT}collections/${slug(make)}`);
              tdMake.rowSpan = makeRowCount;
              tr.appendChild(tdMake);
              makeRowInserted = true;
            }

            if (!modelRowInserted) {
              const tdModel = linkTd(model, entry.modelUrl);
              tdModel.rowSpan = entries.length;
              tr.appendChild(tdModel);
              modelRowInserted = true;
            }

            tr.appendChild(linkTd(entry.body, entry.url, T.tBody || "Body"));
            tr.appendChild(textTd(entry.year, T.tYear || "Year"));
            tr.appendChild(textTd(entry.engine, T.tEngine || "Engine"));
            tr.appendChild(textTd(entry.pcCode, T.tPc || "PC"));
            tr.appendChild(textTd(entry.is_anti_theft ? (T.tYes || "Yes") : (T.tNo || "No"), T.tAntiTheft || "AT"));

            tbody.appendChild(tr);
          });
        }
      }
    }

    /* ── Tabs + search ── */

    let activeTab = "market";
    let renderToken = 0;

    async function render() {
      const token = ++renderToken;
      const tab = activeTab;
      clearTbody();
      loader.style.display = "";
      try {
        const data = await dataFor(tab);
        if (token !== renderToken) return; // another tab / search started meanwhile
        renderTableFromData(filterData(searchInput?.value || "", data));
      } catch (error) {
        console.error("Error loading fitments:", error);
      }
      if (token === renderToken) loader.style.display = "none";
    }

    tabs.forEach((tabBtn) => {
      tabBtn.addEventListener("click", () => {
        if (tabBtn.dataset.tab === activeTab) return;
        activeTab = tabBtn.dataset.tab;
        tabs.forEach((t) => {
          const on = t === tabBtn;
          t.classList.toggle("is-active", on);
          t.setAttribute("aria-selected", on ? "true" : "false");
        });
        render();
      });
    });

    if (searchInput) {
      searchInput.addEventListener("input", debounce(render, 200));
    }

    render();
  });
})();
